import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import {
  nextStep,
  addStepsData,
} from "app/lib/store/slices/steps/personalDetails";
import { usePersonalDetails } from "app/hooks/applicant/usePersonalDetails";
import { APPLICANT } from "app/constants/apiEndPoints";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import { PersonalFormoneData } from "app/utils/types";
import DynamicFormOne from "./dynamicForms/DynamicFormOne";
import { handleApiError } from "app/utils/handleApiError";

const PartOne: React.FC = () => {
  const { applicants } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const applicantId = useSelector(
    (state: RootState) => state.loanTypesSteps.savedIds.applicantID
  );

  const { mutate: submitPersonalDetails, isPending } = usePersonalDetails();
  const dispatch = useDispatch();
  const { formOne, ...others } = useSelector(
    (state: RootState) => state.personalDetails.stepsData
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<PersonalFormoneData>({
    defaultValues: {
      firstName: "",
      middleName: "",
      lastName: "",
      borrower: true,
    },
  });

  const onSubmit = (data: PersonalFormoneData) => {
    submitPersonalDetails(
      {
        url: `${APPLICANT}/${applicantId}/first`,
        data: data,
      },
      {
        onSuccess: () => {
          dispatch(nextStep());
        },
        onError: (error: any) => {
          handleApiError(error);
        },
      }
    );
    dispatch(
      addStepsData({
        ...others,
        formOne: data,
      })
    );
  };

  useEffect(() => {
    if (formOne) {
      reset(formOne);
    } else {
      const { firstName, lastName } = applicants || {};
      setValue("firstName", firstName || "");
      setValue("lastName", lastName || "");
    }
  }, [formOne, reset]);

  return (
    <>
      <ProgressBar progress={0} MB={7} />
      <div className="w-full  sm:w-[70%] xl:w-[40%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Personal Details" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <DynamicFormOne
            control={control}
            errors={errors}
            firstName="firstName"
            middleName="middleName"
            lastName="lastName"
            borrower="borrower"
          />
          <div className="flex justify-end my-10">
            <ContinueButton type="submit" loading={isPending}>
              Next
            </ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PartOne;
